import { render, staticRenderFns } from "./customer-info-item.vue?vue&type=template&id=6c0018e2&scoped=true&"
import script from "./customer-info-item.vue?vue&type=script&lang=js&"
export * from "./customer-info-item.vue?vue&type=script&lang=js&"
import style0 from "./customer-info-item.vue?vue&type=style&index=0&id=6c0018e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0018e2",
  null
  
)

export default component.exports